/**
 * Durchsucht einen cookie nach einem spezifizieren Wert und gibt diesen zurück
 * @param a string - der gesuchte cookie Wert
 * @returns string boolean undefined
 */
export default function getCookieValue(a) {
    const b = document.cookie.match("(^|;)\\s*" + a + "\\s*=\\s*([^;]+)");
    if (b === null) {
        return false;
    }
    return b ? b.pop() : false;
}
